<script lang="ts" setup>
import AUApi from "@/api";
import { ref, reactive, onMounted } from "vue";
import { showDialog } from "@/UIHelper";
import { onShowSite, refreshFullPageContent } from "@/NavigationHelper";
import BaseDialog from "@/components/BaseDialog.vue";
const props = defineProps<{
  buttonItems: ButtonItems[];
  aic: number;
  name: string;
  pers: boolean;
}>();

let editZeitbereich: APIZeitbereich | null = null;
onMounted(async () => {
  // und jetzt?
});
function openSite(item: ButtonItems) {
  const aic = props.aic;
  let site = item.compNameFrm ?? item.compName ?? "";
  // Wenn fullscreen explizit false ist, Komponente im Dialog öffnen statt Vollbild
  if (item.fullscreen === false) {
    showDialog({
      title: item.compTitle ?? "",
      site,
      width: item.width ?? 800,
      height: item.height,
      fullscreen: false,
      data: {
        zeitbereich: AUApi.Current.zeitbereich,
        item,
        aic,
        toggleUebergabe: item.toggle,
        showBack: true,
        name: props.name,
        titel: props.name,
        gotoToday: false,
        site: item,
      },
      onClose: () => {
        refreshFullPageContent();
        return true;
      },
    });
    return;
  }
  onShowSite({
    title: item.compTitle,
    site,
    data: {
      zeitbereich: AUApi.Current.zeitbereich,
      item,
      aic,
      toggleUebergabe: item.toggle,
      showBack: true,
      name: props.name,
      titel: props.name,
      gotoToday: false,
      site: item,
    },
    callOnLeave: () => {
      refreshFullPageContent();
      // return true;
    },
  });
}
function openDialog(item: ButtonItems) {
  const aic = props.aic;
  let site = "BaseDialog";
  if (item.grid) {
    site = "BaseVGrid";
  }
  showDialog({
    title: item.compTitle ?? "",
    width: 500,
    site,
    fullscreen: item.fullscreen,
    data: {
      zeitbereich: AUApi.Current.zeitbereich,
      query: item.query,
      aic,
      pers: props.pers,
    },
    onClose: () => {
      return true;
    },
  });
}
declare interface ButtonItems {
  width?: number;
  height?: number;
  fullscreen: boolean;
  showCustomEditor: boolean;
  query: string;
  compName?: string;
  compNameFrm?: string;
  compTitle?: string;
  icon: string;
  text: string;
  kz?: string;
  aicEig?: number;
  color: string;
  toggle: string;
  tooltip: string;
  stammtyp: number;
  grid?: boolean;
}
</script>
<template>
  <v-btn-toggle
    class="pa-0 pr-1 mb-2"
    v-for="(buttonItem, ux) in props.buttonItems"
    :key="'ui' + ux"
    density="compact"
    variant="tonal"
  >
    <v-tooltip location="bottom" :text="buttonItem.tooltip">
      <template v-slot:activator="{ props }">
        <v-btn
          v-if="!buttonItem.compName && !buttonItem.compNameFrm"
          v-bind="props"
          :base-color="buttonItem.color"
          @click.stop="openDialog(buttonItem)"
          :prepend-icon="buttonItem.icon"
          :text="buttonItem.text"
        >
        </v-btn>
        <v-btn
          v-else
          v-bind="props"
          variant="outlined"
          :color="buttonItem.color"
          @click.stop="openSite(buttonItem)"
          :prepend-icon="buttonItem.icon"
          :text="buttonItem.text"
        ></v-btn>
      </template>
    </v-tooltip>
  </v-btn-toggle>
</template>
<style scoped>
.v-toolbar__content {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 20px;
}
.v-list-item {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  letter-spacing: normal;
  min-height: 48px;
  outline: none;
  padding: 0px;
  position: relative;
  text-decoration: none;
}
</style>
